export default "__VITE_ASSET__718d71e8__"